import React, { Fragment, useRef } from 'react';

// Components

import InstructionalText from '@components/ssap/notifications/InstructionalText';
import Tooltip from '@components/common/tooltip/Tooltip';

// Utils

import { normalizeStringToBooleanValue } from '@utils/normalize/normalizeStringToBooleanValue';


const Checkbox = props => {

    const handleValueChange = e => {
        if (disabled) return;
        const { dataset: { value } } = e.currentTarget;
        props.inputActions.handleFieldChange(!normalizeStringToBooleanValue(value), valueToPass);
    };

    const keyPress = e => {
        const isEnterOrSpace = e.key === ' ' || e.key === 'SpaceBar' || e.key === 'Enter' || e.keyCode === 32 || e.keyCode === 13;
        if (isEnterOrSpace) {
            e.preventDefault();
            handleValueChange(e);
        }
    };

    const {
        inputData: {
            checked,
            classes,
            id,
            isInputRequired,
            name,
            type,
            valueToPass,
            disabled,
            tooltip
        },
        label: {
            dataInstructions,
            dataInstructionsAnchor: anchor,
            replacements,
            text,
            labelClass,
            instructionsViaPortal: [
                isPortal,
                portalMargin
            ] = [],
            skipParsing
        }
    } = props;

    // If it is needed multi-location react portal anchor may be implemented.
    // For a while there are only 2 usages for it (here and in RadioButtons)
    const reactPortalAnchor = useRef(null);

    return (
        <Fragment>
            <div className={`gi-component gi-${type} ${classes} ${tooltip ? 'display-flex flex-align-baseline lead' : ''}`} >
                <Fragment>
                    <input
                        id = { id }
                        data-testid = { `${id}_input` }
                        name = { name }
                        className = { `usa-checkbox__input gi-${ type }__input required-${ isInputRequired }` }
                        type = 'checkbox'
                        aria-checked = { checked }
                        aria-required = { isInputRequired }
                        data-value = { checked }
                        aria-labelledby = { `${ type }_${ id }_label` }
                        checked = { checked === null ? '' : checked }
                        onKeyDown = { keyPress }
                        disabled = { disabled }
                        value = { checked === null ? '' : checked }
                        onChange = { handleValueChange }
                    />

                    <label
                        id = { `${ type }_${ id }_label` }
                        htmlFor = { id }
                        data-testid = { `${id}_label` }
                        data-value = { checked === null ? '' : checked }
                        className = { `usa-checkbox__label gi-${ type }__label ${ labelClass && labelClass.join(' ') }` }
                    >
                        { text }
                        {
                            dataInstructions &&

                            <InstructionalText
                                anchor = { anchor }
                                disabled = { disabled }
                                Component = {
                                    <span data-instructions = { dataInstructions } />
                                }
                                replacements = { replacements }
                                reactPortalAnchor = { isPortal ? reactPortalAnchor : { current: null } }
                                skipParsing = { skipParsing }
                            />
                        }
                    </label>
                    {tooltip && (
                        <Tooltip
                            icon='info-circle'
                            index={0}
                            triggerDecorationClassName=''
                            triggerClassName='margin-l-5'
                            {...tooltip}
                        />
                    )}
                </Fragment>
            </div>

            <div
                ref = { reactPortalAnchor }
                style={ {
                    'marginTop': portalMargin
                } }
            />
        </Fragment>
    );
};

export default Checkbox;
